<template>
  <aside class="p-3 p-lg-4 bg-white">
    <div class="f-17 fw-600 d-none d-lg-block">{{showUser ? 'Settings' : 'Primary'}}</div>
    <button class="btn w-100 d-inline-flex d-lg-none align-items-center bg-info border-0 justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarNav" aria-controls="sidebarNav" aria-expanded="false" aria-label="Toggle navigation" ref="sideBar">
      <span class="f-14 fw-600">{{showUser ? 'Settings' : 'Primary'}}</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6z"/></svg>
    </button>
    <hr class="opacity-25 mb-3 d-none d-lg-block">
    <nav class="navbar navbar-expand-lg p-0">
      <div class="collapse navbar-collapse flex-column" id="sidebarNav">
        <div class="f-11 mt-3 mt-lg-0 mb-3 me-auto" style="color: #607B78">{{showUser ? 'Users' : 'DASHBOARD'}}</div>
        <div class="navbar-nav d-flex flex-column gap-2 me-auto w-100">
          <router-link class="btn p-1.5 border-0 rounded-3 d-inline-flex align-items-center gap-2 f-13 fw-500" to='/' v-if="!showUser && !showMandate" @click="closeDropdown"> <img src="@/assets/bar-icon.svg" alt="">Primary Dashboard</router-link>
          <router-link class="btn p-1.5 border-0 rounded-3 d-inline-flex align-items-center gap-2 f-13 fw-500" to='/performance-report' v-if="!showUser && !showMandate" @click="closeDropdown"> <img src="@/assets/bar-icon.svg" alt="">Performance Report</router-link>
          <router-link class="btn p-1.5 border-0 rounded-3 d-inline-flex align-items-center gap-2 f-13 fw-500" to='/leadsdashboard' v-if="!showUser && !showMandate" @click="closeDropdown"> <img src="@/assets/bar-icon.svg" alt="">Leads Dashboard</router-link>
          <!-- <router-link class="btn p-1.5 border-0 rounded-3 d-inline-flex align-items-center gap-2 f-13 fw-500" to='/demandfunnel' v-if="!showUser && !showMandate"> <img src="@/assets/bar-icon.svg" alt="">Demand Funnel</router-link> -->
          <router-link class="btn p-1.5 border-0 rounded-3 d-inline-flex align-items-center gap-2 f-13 fw-500" to='/settings' v-if="showUser && !showMandate" @click="closeDropdown"> <img src="@/assets/user-icon.svg" width="18" height="18" alt="">Manage Users</router-link>
          <router-link class="btn p-1.5 border-0 rounded-3 d-inline-flex align-items-center gap-2 f-13 fw-500" to='/salarycosts' v-if="showUser && !showMandate" @click="closeDropdown"> <img src="@/assets/salary-costs.svg" width="18" height="18" alt="">Salary Costs</router-link>
          <!-- <router-link class="btn p-1.5 border-0 rounded-3 d-inline-flex align-items-center gap-2 f-13 fw-500" to='/syndicate-dashboard' v-if="$route.path === '/syndicate-dashboard'"> <img src="@/assets/bar-icon.svg" alt="">Syndicate Dashboard</router-link>
          <router-link class="btn p-1.5 border-0 rounded-3 d-inline-flex align-items-center gap-2 f-13 fw-500" to='/mandate-dashboard' v-if="$route.path === '/mandate-dashboard'"> <img src="@/assets/bar-icon.svg" alt="">Mandate Dashboard</router-link> -->
        </div>
      </div>
    </nav>
    
  </aside>
</template>
<style scoped>
.router-link-active{
  background-color: rgba(240, 246, 251);
}
aside{
    position: sticky;
    top: 62px;
    width: 100%;
    z-index: 1000;
  }

@media(min-width: 991px){
  aside{
    width: auto;
    min-width: 234px;
    height: calc(100vh - 61px);
    height: calc(100dvh - 61px);
  }
  
  }
</style>
<script>
// import {deleteLogoutCookies} from '@/assets/scripts/utility.js';
  export default {
    methods: {
      logout(){
        swal({
          title: "Are you sure?",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
            this.$axios.delete('users/logout')
              .then(res => {
                // deleteLogoutCookies();
                this.$router.replace({name: 'Login'});
              })
              .catch(err => console.log(err));
          }
        });
      },
      closeDropdown() {
        if (window.innerWidth < 992) {
          this.$refs?.sideBar?.click();
        }
      }
    },
    computed: {
      userName(){
        return this.$cookies.get('postsales-user-name')
      },
      userRole(){
        return this.$cookies.get('postsales-user-role')
      },
      showUser() {
        return this.$route.name === 'Settings' || this.$route.name === 'SalaryCosts';
      },
      showMandate(){
        return this.$route.name === 'MandateDashboard' || this.$route.name === 'SyndicateDashboard';
      }
    },
    // mounted(){
    //   // $('[data-widget="treeview"]').Treeview('init');
    // }
  }
</script>